import React, { useState} from 'react';

const CommunicationsFilterContainerViewing = ({ layersVisibilityCommunications, toggleLayerVisibilityCommunications, handleNumberPonBoxCheckboxChange, visibleNumberPonBox}) => {
 
  const [isVisibleDiv, setIsVisibleDiv] = useState(false);

  function toggleVisibilityDiv() {
    setIsVisibleDiv(!isVisibleDiv);
  }

    return (
      <React.Fragment>
      <button onClick={toggleVisibilityDiv} className={isVisibleDiv ? 'buttonIsHideDrawer' : 'buttonIsHideDrawer2'}>
        {isVisibleDiv ? 'Коммуникации: скрыть' : 'Коммуникации: показать'}
      </button>

  {isVisibleDiv && ( 
    <div className='equipmentDiv' style={{marginTop: "10px" ,textShadow: '2px 2px 4px #242424'}}>
      <label className='typeLabelDiv'>Коммуникации</label>
      <hr className='horizontalLineDrawer'/>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={layersVisibilityCommunications.iconManhole}
          onChange={() => toggleLayerVisibilityCommunications('iconManhole')}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Колодец</label>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={layersVisibilityCommunications.iconPillar}
          onChange={() => toggleLayerVisibilityCommunications('iconPillar')}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Опора</label>
      </div> 

      <div style={{ display: 'flex', alignItems: 'normal' }}>
        <input
          type="checkbox"
          checked={layersVisibilityCommunications.iconCoupling}
          onChange={() => toggleLayerVisibilityCommunications('iconCoupling')}
          style={{ marginRight: '5px' }}
        />
        <label style={{color: '#bdbdbd'}}>Муфта</label>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={layersVisibilityCommunications.iconFob}
          onChange={() => toggleLayerVisibilityCommunications('iconFob')}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Фоб</label>
      </div>                 
      <hr className='horizontalLineDrawer'/>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={layersVisibilityCommunications.iconPonBox}
          onChange={() => toggleLayerVisibilityCommunications('iconPonBox')}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd' }}>Пон-бокс</label>
      </div>       
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={visibleNumberPonBox}
          onChange={() => handleNumberPonBoxCheckboxChange()}
          style={{marginLeft:"20px", marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px', color: '#bdbdbd' }}>номер бокса</label>
      </div>                
    </div>  
    )}
    </React.Fragment>
  );
}

export default CommunicationsFilterContainerViewing;